//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { declOfNum, getArrForTitle, getContentByCode } from "../../utils/utils";
export default {
  data(){
    return {
      defaultPosition: true,
      currentTotal: {}
    }
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll)
    if (this.totalOpenMasterpieces.data) {
      this.makeObjectFromTotal(this.totalOpenMasterpieces.data.data)
    }
  },
  computed: {
    image() {
      const images = this.getImagesForGalleryPreview?.data?.data || []
      if (process.env.NODE_ENV === 'development') {
        const result = images.map(elem => `https://my.tretyakov.ru${elem}`)
        return result.length ? result[0] : ''
      }
      return images.length ? images[0] : ''
    }
  },
  methods: {
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
      // return getArrForTitle(getContentByCode(this.getTextBlocks.data.data, code))
    },
    getDeclination(num, key){
      if (this.$i18n.locale === 'en') {
        return this.$tc(key, num > 1 ? 2 : 1)
      } else {
        return this.$tc(key, declOfNum(num));
      }
    },
    handleScroll() {
      this.defaultPosition = false
      window.removeEventListener('scroll', this.handleScroll, false);
    },
    makeObjectFromTotal(total) {
      const result = {}
      const firstResult = {}
      const currentTotal = total.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').split('')
      currentTotal.forEach((elem, i) => {
        firstResult[i + 1] = -1
        result[i + 1] = elem === ' ' ? -1 : Number(elem)
      });
      this.currentTotal = firstResult
      setTimeout(() => this.currentTotal = result, 500)
    }
  },
  chimera: {
    totalOpenMasterpieces () {
      return {
        url: '/api/getOpenedItemsAmount/',
        key: 'total-open-masterpieces',
        auto: true,
        params: {
          lang: this.$i18n.locale || 'ru'
        },
        on: {
          success () {
            this.makeObjectFromTotal(this.totalOpenMasterpieces.data.data)
          }
        }
      }
    },
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'gallery-preview-subtitle',
        auto: true,
        params: {
          code: ['gallery-preview-subtitle'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getImagesForGalleryPreview () {
      return {
        url: '/api/v1/fileFromFolder/get',
        key: `getImagesForGalleryPreview`,
        auto: true,
        params: {
          folder: 'virtual-gallery-main-image'
        }
      }
    }
  }
}
